
export function cookiesAreEnabled() : boolean {
  const cookieVal = "cookies=on"

  // set a cookie
  document.cookie = cookieVal

  return document.cookie.indexOf(cookieVal) > -1
}